// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"7dea3a99","297":"843e2586","643":"6e7a4ccc"}[chunkId] + ".chunk.js";
};